module.exports = __webpack_public_path__ + "Roboto-Medium.303ded6436dcf7ea7515.woff";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Medium.woff
// module id = 118
// module chunks = 17